import styled from 'styled-components'

interface StyleProps {
    show: boolean
}

export const PopUpContainer = styled.div<StyleProps>`
    display: ${props => (props.show ? 'flex' : 'none')};
`
